//#region Appointment helpers
function GetAppointmentType(uniqueIdOrTypeName) {
    if (uniqueIdOrTypeName === ''
        || uniqueIdOrTypeName === null
        || uniqueIdOrTypeName === undefined) {
        return undefined;
    }

    var types = window.calendarConfiguration.appointmentTypes;
    for (var i = 0; i < types.length; i++) {
        var type = types[i];
        if (type.id === uniqueIdOrTypeName || type.type === uniqueIdOrTypeName) {
            return type;
        }
    }

    console.warn("No appointment type with id " + uniqueIdOrTypeName + " found");
}

//#endregion

//#region DOM Helpers
function CreateElement(elementName, className, innerText, innerHTML) {
    if (!elementName) {
        return;
    }
    var newElement = document.createElement(elementName);
    if (className && className.length > 0) {
        newElement.className = className;
    }
    if (innerText && innerText.length > 0) {
        newElement.innerText = innerText;
    }
    if (innerHTML && innerHTML.length > 0) {
        newElement.innerHTML = innerHTML;
    }
    return $(newElement);
}

//#endregion

//#region Error Panel
function ShowErrorPanel(text) {
    var $errorTextContainer = $('#m-modal__notification-error-text');
    var output = text.replace(/(\r\n|\n|\r)/gm, "<br>");
    $errorTextContainer.html(output);
    $('.m-modal__notification--error').show();
}

// The "ok" button functionality is in 004_globalEvents.js
//#endregion

//#region Date and Time helper
function CheckForValidWorkingTimes(pro, start, end) {
    if (!pro || !pro.workingTimes)
        return false;

    for (var i = 0; i < pro.workingTimes.length; i++) {
        var wt = pro.workingTimes[i];

        // Ensure we only check working times for the required day.
        if (start.day() !== wt.DayOfWeek) {
            continue;
        }

        // Construct moment objects from the working times.
        var wtStartSplit = wt.StartTime.split(':');
        var wtEndSplit = wt.EndTime.split(':');
        var wtStart = moment(start).hour(wtStartSplit[0]).minute(wtStartSplit[1]);
        var wtEnd = moment(end).hour(wtEndSplit[0]).minute(wtEndSplit[1]);

        // Check if the pro works between start and end. (end is optional)
        if (start >= wtStart && ((end && end <= wtEnd) || !end)) {
            return true;
        }

        if (wt.AlternativeTimes) {
            var wtAltStartSplit = wt.AltStartTime.split(':');
            var wtAltEndSplit = wt.AltEndTime.split(':');
            var wtAltStart = moment(start).hour(wtAltStartSplit[0]).minute(wtAltStartSplit[1]);
            var wtAltEnd = moment(end).hour(wtAltEndSplit[0]).minute(wtAltEndSplit[1]);

            if (start >= wtAltStart && ((end && end <= wtAltEnd) || !end)) {
                return true;
            }
        }
    }

    return false;
}

function CalculateWorkingTimes(isEndTime, pro, forDate) {
    var result = [];

    var minTime = pro ? pro.minTime : window.calendarConfiguration.businessHoursMinTime;
    var maxTime = pro ? pro.maxTime : window.calendarConfiguration.businessHoursMaxTime;

    if (pro && forDate && forDate._isAMomentObject) {
        var requiredDay = forDate.day();
        var possibleWorkingTimes = pro.workingTimes.filter(function(wt) {
            return wt.DayOfWeek === requiredDay;
        });
        // Add all working times for the selected pro and the day of the event.
        var groupId = 0;
        for (var i = 0; i < possibleWorkingTimes.length; i++) {
            var wt = possibleWorkingTimes[i];
            result = result.concat(_calculateWorkingTimesInternal(isEndTime, wt.StartTime, wt.EndTime, groupId++));
            if (wt.AlternativeTimes) {
                result = result.concat(_calculateWorkingTimesInternal(isEndTime, wt.AltStartTime, wt.AltEndTime, groupId++));
            }
        }
    } else {
        result = result.concat(_calculateWorkingTimesInternal(isEndTime, minTime, maxTime));
    }

    result.sort(function(a, b) {
        if (a.m < b.m)
            return -1;
        if (a.m > b.m)
            return 1;
        return 0;
    });

    return result;
}

function _calculateWorkingTimesInternal(isEndTime, minTime, maxTime, groupId) {
    var result = [];

    var minHour = parseInt(minTime.split(':')[0]);
    var minMinutes = parseInt(minTime.split(':')[1]);
    var maxHour = parseInt(maxTime.split(':')[0]);
    var maxMinutes = parseInt(maxTime.split(':')[1]);
    var slotDuration = parseInt(window.calendarConfiguration.calendarRaster);

    var now = moment().utcOffset(0, true);

    var start = minHour * 60 + minMinutes;
    var end = maxHour * 60 + maxMinutes;
    for (var i = start; i < end; i += slotDuration) {
        if (isEndTime && i === start) {
            continue;
        }
        var hour = Math.floor(i / 60);
        var minutes = i % 60;
        now.hour(hour);
        now.minute(minutes);
        var time1 = {t: now.format("LT"), m: moment(now), g: groupId };
        result.push(time1);
    }
    if (isEndTime) {
        now.hour(maxHour);
        now.minute(maxMinutes);
        var time2 = {t: now.format('LT'), m: moment(now), g: groupId };
        result.push(time2);
    }

    return result;
}

/**
 * creates options to select time slots
 * - selector => JQuery selector for the select element to init
 * - isEndTime => if valid, a final time option is added with max time value
 * - requires global variable 'window.calendarConfiguration'
 * @param {any} $targetElement
 * @param {any} isEndTime
 * @param {any} pro
 * @param {any} keepSelectedTimeIfPossible
 */
function InitTimeSelection($targetElement, isEndTime, pro, forDate, keepSelectedTimeIfPossible) {
    if (!$targetElement) {
        console.warn("InitTimeSelection - target element is missing");
        return;
    }

    var times = CalculateWorkingTimes(isEndTime, pro, forDate);
    var index = 0;
    var selectedTime = null;
    if (keepSelectedTimeIfPossible) {
        selectedTime = $targetElement.val();
    }

    if ($targetElement.children()) {
        $targetElement.children().remove();
    }

    for (var i = 0; i < times.length; i++) {
        var time = times[i];
        var formattedTime = time.m.format('HH:mm');

        $targetElement.append('<option value="' + formattedTime + '" data-index="' + index + '" data-group="' + time.g + '">' + time.t + '</option>');

        index++;
    }

    if (keepSelectedTimeIfPossible && selectedTime) {
        if ($targetElement.find('option[value="' + selectedTime + '"]').length) {
            $targetElement.val(selectedTime);
        }
    }
}
//#endregion

//#region Location helpers
function GetLocationById(id) {
    var location = calendarConfiguration.resources.find(function (r) {
        return r.id === id;
    });
    if (!location) {
        location = FindResourceById(id);
    }
    return location;
}

//#endregion

//#region Business Hours helpers
function GetBusinessHourMomentObjects(bh, baseTime) {
    if (!baseTime) {
        baseTime = moment().utcOffset(0, true);
    }

    var bhStartSplit = bh.start.split(':');
    var bhEndSplit = bh.end.split(':');

    var bhStart = moment(baseTime).hour(bhStartSplit[0]).minute(bhStartSplit[1]);

    var bhEnd = moment(baseTime).hour(bhEndSplit[0]).minute(bhEndSplit[1]);

    return {
        start: bhStart,
        end: bhEnd
    };
}

function GetValidBusinessHours(start, end, container) {
    var dayOfWeek = start.day();

    container = container || calendarConfiguration.businessHours;

    for (var bhKey in container) {
        if (container.hasOwnProperty(bhKey)) {
            var bh = container[bhKey];

            var validDay = bh.dow.find(function (d) {
                return d === dayOfWeek;
            });

            if (validDay !== dayOfWeek) {
                continue;
            }

            var bhMoment = GetBusinessHourMomentObjects(bh, start);

            if (start >= bhMoment.start && end <= bhMoment.end) {
                return {
                    businessHours: bh,
                    start: bhMoment.start,
                    end: bhMoment.end,
                    resourceId: bh.club
                };
            }
        }
    }

    return null;
}

function FindResourceById(resourceId) {
    var resources = $calendar.fullCalendar('getResources');

    if (!resources) {
        return;
    }

    for (var ck in resources) {
        if (!resources.hasOwnProperty(ck)) {
            continue;
        }

        var club = resources[ck];

        if (club.id === resourceId) {
            return club;
        }

        if (!club.children || !club.children.length) {
            continue;
        }

        for (var pk in club.children) {
            if (!club.children.hasOwnProperty(pk)) {
                continue;
            }

            var pro = club.children[pk];

            if (pro.id === resourceId) {
                return pro;
            }
        }
    }
}

//#endregion

//#region Overlap checking helper
function IsOverlappingWithAnyEvent(start, end) {
    var startTime = GetMomentAsTime(start);
    var endTime = GetMomentAsTime(end);

    var overlappingEvents = $calendar.fullCalendar('clientEvents', function (event) {
        //A lot of the events represent empty entries of the raster.
        //These have to be ignored and don't count as overlapping events
        if (event['appointmentId'] === undefined) {
            return false;
        }

        var eventStartTime = GetMomentAsTime(event.start);
        var eventEndTime = GetMomentAsTime(event.end);

        //is start time clicked before event start in question? => is end time clicked after start time event? => overlap
        //is start time clicked after event start in question? => is start time clicked before end time event? => overlap
        return (startTime <= eventStartTime && endTime > eventStartTime)
            || (startTime >= eventStartTime && startTime < eventEndTime);
    });

    return overlappingEvents !== undefined && overlappingEvents.length > 0;
}
//#endregion

//#region Get Filtered List helper
/**
 * Filters an array by checking whether a given property has a value
 * @param {array} array - array to filter
 * @param {array} propertyNames - name of properties, with a value being expected for at least one of them
 * @return filtered array. empty if no entries found
 */
function GetFilteredArrayByAnyProperty(array, propertyNames) {
    return array && array.length > 0
        ? array.filter(function (item) {
            var hasProperty = false;

            //Check array item for property
            propertyNames.forEach(function(property) {
                if (item[property]) {
                    hasProperty = true;
                }
            });

            //return, if at least one property was found
            if (hasProperty) {
                return item;
            }
        })
        : [];
}
//#endregion

//#region Appointment Telephone Numbers helpers
/**
 * Takes the array of participants,
 * and returns a narrowed down version of the objects for those who do.
 * @param {array} participants - an array of participant objects
 * @return array with narrowed down version of the object
 */
function GetMappedParticipantsWithContactInformation(participants) {
    var mappedParticipants = participants.map(function (item) {
        return {
            firstName: item['firstName'],
            lastName: item['lastName'],
            phoneNumber: item["phoneNumber"],
            email: item["email"]
        };
    });

    return mappedParticipants;
}

/**
 * Converts participant list to a character seperated list.
 * FullName, PhoneNumber and EmailAddress are separated by ','.
 * Participants are separated by '|'.
 * @param {array} participants - an array of participant objects containing "fullName", "phoneNumber" and "emailAddress
 * @return A string containing "fullName" and "phoneNumber" comma-separated
 */
function ConvertParticipantsToContactListString(participants) {
    var participantListAsString = participants.map(function (item) {
        var contactInfo = item['firstName'] + ' ' + item['lastName'];

        contactInfo += ',';
        if (item['phoneNumber']) {
            contactInfo += item['phoneNumber'];
        }

        contactInfo += ',';
        if (item["email"]) {
            contactInfo += item["email"];
        }

        return contactInfo;
    });

    return participantListAsString.join('|');
}

/**
 * Reads the description attribute of the phone number icon
 * to get all participants with their phone number.
 * FullName, PhoneNumber and EmailAddress are separated by ','.
 * Participants are separated by '|'.
 * @param {element} $el - represents the phone icon, whose description contains the phone numbers and email addresses
 * @return An array of objects containing "fullName", "phoneNumber" and "email", if there is data
 */
function GetParticipantContactListFromElement(element) {
    var phoneList = element.attr("data-contactList");
    var participantList = [];

    if (phoneList) {
        phoneList.split("|").forEach(function (item) {
            var properties = item.split(',');
            participantList.push({
                fullName: properties[0],
                phoneNumber: properties[1],
                email: properties[2]
            });
        });
    }

    return participantList;
}

/**
 * Creates HTML-elements for each participant in the list
 * @param {any} participants
 * @return All participants and their phone number, using HTML-elements
 */
function GetContactListAsElementString(participants) {
    var html = "";
    participants.forEach(function (item) {
        participantHtml = "<span>" + item["fullName"] + ": ";

        if (item["phoneNumber"]) {
            //ancher element with telephone number
            participantHtml += "<a href='tel:" + item["phoneNumber"] + "'>"
                                + item["phoneNumber"]
                                + "</a>";

            //Divider is only necessary, if both properties exist
            if (item["email"]) {
                participantHtml += " / ";
            }
        }

        if (item["email"]) {
            //anchor element with emailAddress
            participantHtml += "<a href='mailto:" + item["email"] + "'>"
                                + item["email"]
                                + "</a>";
        }

        participantHtml += "</span>";

        html += participantHtml;
    });

    return html;
}
//#endregion

//#region Moment (https://fullcalendar.io/docs/v3/moment) converting helper
function GetMomentAsTime(moment) {
    return new Date(moment._d).getTime();
}
//#endregion

//#region JavaScript prototypes
String.prototype.contains = function (search) {
    return this.toString().indexOf(search) !== -1;
};

String.prototype.containsIgnoreCase = function (search) {
    return this.toLowerCase().contains(search.toLowerCase());
};

if (!Array.prototype.find) {
    Array.prototype.find = function (predicate) {
        if (this == null) {
            throw new TypeError('Array.prototype.find called on null or undefined');
        }
        if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
        }
        var list = Object(this);
        var length = list.length >>> 0;
        var thisArg = arguments[1];
        var value;

        for (var i = 0; i < length; i++) {
            value = list[i];
            if (predicate.call(thisArg, value, i, list)) {
                return value;
            }
        }
        return undefined;
    };
}

Array.prototype.compareArray = function (target) {
    return this.filter(function (sourceItem) {
        return target.filter(function (targetItem) {
            return sourceItem === targetItem;
        }).length;
    });
};
//#endregion

//#region tooltip helper
function SetEventTooltip($el) {
    var closeTooltipOnClick = function (e) {
        var closest = $(e.target).closest($el);
        if (closest || closest.size()) {
            return;
        }
        $('body').off('touchend', closeTooltipOnClick);
        $el.tooltip('close');
    };
    $el.tooltip({
        tooltipClass: "fc-info-tooltip",
        position: {my: "right bottom-24", at: "right bottom" },
        content: function () {
            var element = $(this);
            var occurrenceAppointmentType = element.attr("data-occurrenceAppointmentType");
            var desc = element.attr("data-desc");
            var participants = GetParticipantContactListFromElement(element);
            var title = element.attr("title");
            var appliance = element.attr("data-appliance");
            var html = "";
            if (occurrenceAppointmentType) {
                html += "<span class='desc'><b>" + occurrenceAppointmentType + "</b></span><br>";
            }
            if (appliance) {
                html += "<span class='desc'>" + appliance + "</span><br>";
            }
            if (desc) {
                html += "<span class='desc'><b>"
                    + desc.replace("<", "&lt;").replace("\"", "&quot;")
                    + "</b></span><br>";
            }
            if (participants && participants.length > 0) {
                html += GetContactListAsElementString(participants);
            }
            if (title) {
                title.split(",").forEach(function (item) {
                    html += "<span>" + item + "</span>";
                });
            }
            return html;
        },
        open: function (event, ui) {
            if (isTouchCapable) {
                $('body').on('touchend', closeTooltipOnClick);
            }

            //Makes tooltip stay open while it's hovered over (https://stackoverflow.com/questions/16660576/only-close-tooltip-if-mouse-is-not-over-target-or-tooltip)
            else {
                if (typeof (event.originalEvent) === 'undefined') {
                    return false;
                }

                var $id = $(ui.tooltip).attr('id');

                // close any lingering tooltips
                $('div.ui-tooltip').not('#' + $id).remove();
            }
        },
        close: function (event, ui) {
            //Makes tooltip stay open while it's hovered over (https://stackoverflow.com/questions/16660576/only-close-tooltip-if-mouse-is-not-over-target-or-tooltip)
            ui.tooltip.hover(function () {
                $(this).stop(true).fadeTo(400, 1);
            },
                function () {
                    $(this).fadeOut('400', function () {
                        $(this).remove();
                    });
                });
        }
    });
}
//#endregion
